(function () {
  function init(root) {
    if (!root || root.dataset.mtSubscribeReady === 'true') return;
    root.dataset.mtSubscribeReady = 'true';

    var form = root.querySelector('.mt-subscribe__form');
    var message = root.querySelector('[data-mt-subscribe-message]');
    if (!form || !message) return;

    // Preview-matching instant feedback; Shopify still receives the customer form post.
    form.addEventListener('submit', function (event) {
      if (!form.checkValidity()) return;
      event.preventDefault();
      form.classList.add('is-hidden');
      message.classList.add('is-visible');

      var action = form.getAttribute('action') || window.location.pathname;
      var data = new FormData(form);
      fetch(action, {
        method: 'POST',
        body: data,
        headers: { Accept: 'application/json' }
      }).catch(function () {});
    });
  }

  function boot() {
    document.querySelectorAll('[data-mt-subscribe]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-mt-subscribe]');
    if (root) {
      root.dataset.mtSubscribeReady = 'false';
      init(root);
    }
  });
})();
